/**
  * 主页模块接口列表
  */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例

const homeApi = {
    GetTokenUser: `${base.qa}/User/GetTokenUser`,
    // getmenu: `${base.qa}/getmenu`,
    getmenu: `${base.qa}/RoleUserModule/GetLoginUserModule`,
}

const home = {
    GetTokenUser () {
        return axios.get(homeApi.GetTokenUser)
    },
    getMenu () {
        return axios.get(homeApi.getmenu)
    },
}


export default home;